import React, { Component, useState } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import Papa from "papaparse";
import {Text} from 'troika-three-text'

import Intro from "./Intro";
import Loading from "./Loading";
import Modal from "./Modal";
import About from "./About";
import Tooltip from "./tooltip";
import Header from "./Header";

const allowedExtensions = ["csv"];

class AA extends Component {
  

  camera = new THREE.PerspectiveCamera(
    45,
    window.innerWidth / window.innerHeight,
    1,
    4000
  );
  insurance = {

    'auto': 0,
    'home': 1,
    'life': 2,
    'disable': 3,
    'pet': 4,
    'health': 5,
    'smallbussiness': 6,
    'liability': 7

  }

  data = []
    


  mixers = []
  mixer
  mouse = new THREE.Vector2();
  raycaster = new THREE.Raycaster();
  fire_locations = require("../../JSON/US_20200101_prediction_2.json");
  target = 0;

  onMouseMove(event, mouse, raycaster, camera, scene) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    //fire_locations
    // normal tooltip
    // this.jQuery('tooltip').style.visibility = 'hidden';
    document.getElementById("tooltip").style.left =
      (event.clientX / window.innerWidth) * 100 + 2 + "%";
    document.getElementById("tooltip").style.top =
      (event.clientY / window.innerHeight) * 100 - 5 + "%";

    raycaster.setFromCamera(mouse, camera);
    var intersects = raycaster.intersectObjects(scene.children, true);
    var object = intersects.length ? intersects[0].object : null;

    if (
      document.getElementById("modal").style.display !== "none" ||
      document.getElementById("loading").style.display !== "none" ||
      document.getElementById("about").style.display !== "none" ||
      document.getElementById("intro").style.display !== "none"
    ) {
      object = null;
    }

    if (
      object !== null &&
      (object.name == 'SmallBusiness' ||
      object.name == 'home' ||
      object.name == "life" ||
      object.name == "pet" ||
      object.name == "auto"||
      object.name == 'health' ||
      object.name == 'ClickMe'
      )
    ) {
      document.getElementsByTagName("body")[0].style.cursor = "pointer";
      this.jQuery("tooltip").innerHTML = object.name
      this.jQuery("tooltip").style.visibility = "visible";
    } else {
      document.getElementsByTagName("body")[0].style.cursor = "default";
      this.jQuery("tooltip").style.visibility = "hidden";

    }
      // // DEBUG
      // if(object!=null){
      // 	this.jQuery('tooltip').innerHTML = object.name;
      // 	this.jQuery('tooltip').style.visibility = 'visible';

  }

  mouseClick(scene, raycaster, mouse, camera) {
    this.jQuery("tooltip").style.visibility = "hidden";
    if(document.getElementById('modal').style.display!='none' || document.getElementById('intro').style.display!='none'){
      document.getElementById("modal").style.display = 'none'
      document.getElementById('intro').style.display ='none'
    } else if (document.getElementById("modal").style.display == "none") {

        raycaster.setFromCamera(mouse, camera);

        var intersects = raycaster.intersectObjects(scene.children, true);

        var object = intersects.length ? intersects[0].object : null;

        

        if (object !== null && object.name == 'home') {
          var from = new THREE.Vector3(
            camera.position.x,
            camera.position.y,
            camera.position.z
          );
          var to = this.angles2xyz(
            150,100,500
          );

          new TWEEN.Tween({
            x: from.x,
            y: from.y,
            z: from.z,
          })
            .to({ x: to[0], y: to[1], z: to[2] }, 2000)
            .onUpdate(function (val) {
              camera.position.x = val.x;
              camera.position.y = val.y;
              camera.position.z = val.z;
            })
            .easing(TWEEN.Easing.Elastic.Out)
            .repeat()
            .start()
            .onComplete(() => {
              this.jQuery("modal").style.display = "flex";
              this.jQuery('insurance_type').innerHTML =  this.data[this.insurance[object.name]].Title
              this.jQuery('insurance_description').innerHTML = this.data[this.insurance[object.name]].Description
              this.jQuery('call_to_action').innerHTML = this.data[this.insurance[object.name]]["Action-Call"]
            });

          
      } else if (object !== null && object.name == 'life') {
        var from = new THREE.Vector3(
          camera.position.x,
          camera.position.y,
          camera.position.z
        );
        var to = this.angles2xyz(
          5, -90, 350
        );

        new TWEEN.Tween({
          x: from.x,
          y: from.y,
          z: from.z,
        })
          .to({ x: to[0], y: to[1], z: to[2] }, 500)
          .onUpdate(function (val) {
            camera.position.x = val.x;
            camera.position.y = val.y;
            camera.position.z = val.z;
          })
          .easing(TWEEN.Easing.Back.Out)
          .repeat()
          .start()
          .onComplete(() => {
            this.jQuery("modal").style.display = "flex";
            this.jQuery("modal").style.display = "flex";
            this.jQuery('insurance_type').innerHTML =  this.data[this.insurance[object.name]].Title
            this.jQuery('insurance_description').innerHTML = this.data[this.insurance[object.name]].Description
            this.jQuery('call_to_action').innerHTML = this.data[this.insurance[object.name]]["Action-Call"]
            this.jQuery('img').src = "/Images/nathen.PNG"
          });

        
      }

    else if (object !== null && object.name == 'SmallBusiness') {
      var from = new THREE.Vector3(
        camera.position.x,
        camera.position.y,
        camera.position.z
      );
      var to = this.angles2xyz(
        150,100,400
      );

      new TWEEN.Tween({
        x: from.x,
        y: from.y,
        z: from.z,
      })
        .to({ x: to[0], y: to[1], z: to[2] }, 500)
        .onUpdate(function (val) {
          camera.position.x = val.x;
          camera.position.y = val.y;
          camera.position.z = val.z;
        })
        .easing(TWEEN.Easing.Back.Out)
        .repeat()
        .start()
        .onComplete(() => {
          this.jQuery("modal").style.display = "flex";
          this.jQuery("modal").style.display = "flex";
          this.jQuery('insurance_type').innerHTML =  this.data[6].Title
          this.jQuery('insurance_description').innerHTML = this.data[6].Description
          this.jQuery('call_to_action').innerHTML = this.data[6]["Action-Call"]
          this.jQuery('img').src = "/Images/scared.PNG"
        });

      
  } else if (object !== null && object.name == 'health') {
    var from = new THREE.Vector3(
      camera.position.x,
      camera.position.y,
      camera.position.z
    );
    var to = this.angles2xyz(
      25, -5, 300
    );

    new TWEEN.Tween({
      x: from.x,
      y: from.y,
      z: from.z,
    })
      .to({ x: to[0], y: to[1], z: to[2] }, 500)
      .onUpdate(function (val) {
        camera.position.x = val.x;
        camera.position.y = val.y;
        camera.position.z = val.z;
      })
      .easing(TWEEN.Easing.Back.Out)
      .repeat()
      .start()
      .onComplete(() => {
        this.jQuery("modal").style.display = "flex";
        this.jQuery("modal").style.display = "flex";
        this.jQuery('insurance_type').innerHTML =  this.data[this.insurance[object.name]].Title
        this.jQuery('insurance_description').innerHTML = this.data[this.insurance[object.name]].Description
        this.jQuery('call_to_action').innerHTML = this.data[this.insurance[object.name]]["Action-Call"]
        this.jQuery('img').src = "/Images/happy.PNG"
      });

    
  }
  else if (object !== null && object.name == 'ClickMe') {
  
        this.jQuery("modal").style.display = "flex";
        this.jQuery("modal").style.display = "flex";
        this.jQuery('insurance_type').innerHTML =  'We have other cool things at State Farm'
        this.jQuery('insurance_description').style.display = 'none'
        this.jQuery('input').style.display = 'none'
        this.jQuery('call_to_action').innerHTML = 'Click to Learn more :D'
        this.jQuery('img').src = "/Images/jake.PNG"

    
  }


    else if (object !== null && object.name == 'pet') {
      var from = new THREE.Vector3(
        camera.position.x,
        camera.position.y,
        camera.position.z
      );
      var to = this.angles2xyz(
        5, -40, 300
      );

      new TWEEN.Tween({
        x: from.x,
        y: from.y,
        z: from.z,
      })
        .to({ x: to[0], y: to[1], z: to[2] }, 500)
        .onUpdate(function (val) {
          camera.position.x = val.x;
          camera.position.y = val.y;
          camera.position.z = val.z;
        })
        .easing(TWEEN.Easing.Back.Out)
        .repeat()
        .start()
        .onComplete(() => {
          this.jQuery("modal").style.display = "flex";
          this.jQuery("modal").style.display = "flex";
          this.jQuery('insurance_type').innerHTML =  this.data[this.insurance[object.name]].Title
          this.jQuery('insurance_description').innerHTML = this.data[this.insurance[object.name]].Description
          this.jQuery('call_to_action').innerHTML = this.data[this.insurance[object.name]]["Action-Call"]
        this.jQuery('img').src = "/Images/an.PNG"

        });
  }


  else if (object !== null && object.name == 'auto') {
    var from = new THREE.Vector3(
      camera.position.x,
      camera.position.y,
      camera.position.z
    );
    var to = this.angles2xyz(
      25, 60, 450
    );

    new TWEEN.Tween({
      x: from.x,
      y: from.y,
      z: from.z,
    })
      .to({ x: to[0], y: to[1], z: to[2] }, 500)
      .onUpdate(function (val) {
        camera.position.x = val.x;
        camera.position.y = val.y;
        camera.position.z = val.z;
      })
      .easing(TWEEN.Easing.Back.Out)
      .repeat()
      .start()
      .onComplete(() => {
        this.jQuery("modal").style.display = "flex";
        this.jQuery("modal").style.display = "flex";
        this.jQuery('insurance_type').innerHTML =  this.data[this.insurance[object.name]].Title
        this.jQuery('insurance_description').innerHTML = this.data[this.insurance[object.name]].Description
        this.jQuery('call_to_action').innerHTML = this.data[this.insurance[object.name]]["Action-Call"]
        this.jQuery('img').src = "/Images/ryan.PNG"
      });

    
}
      
}
  }

  jQuery(id) {
    return document.getElementById(id);
  }

  long2angles(long) {
    return long + 94;
  }

  angles2xyz(rotX, rotY, distance) {
    rotX = (rotX * Math.PI) / 180;
    rotY = ((rotY + 90) * Math.PI) / 180;
    let x = Math.cos(rotX) * Math.cos(rotY);
    let y = Math.cos(rotX) * Math.sin(rotY);
    let z = Math.sin(rotX);
    return [x * distance, z * distance, y * distance];
  }

  componentDidMount() {

    
    

    console.warn = () => {};
    console.error = () => {};
    document.getElementById("modal").style.display = "none";
    document.getElementById("loading").style.display = "block";
    // document.getElementById("loading").style.display = "none";
    document.getElementById("about").style.display = "none";

    let parent = this;
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));
    var clock = new THREE.Clock()
    clock.start();
    console.log('clock started', clock.getDelta())
    console.log('clock started', clock.getDelta())


    var commonConfig = { delimiter: "," };

    console.log('DB')
    Papa.parse(
      "/DB/Database.csv",
      {
        ...commonConfig,
        header: true,
        download: true,
        complete: (result) => {
          this.data = result.data
          console.log('data', this.data)
        }
      }
    );
    

    var renderer = new THREE.WebGLRenderer({antialias: true,  alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFShadowMap;
    // renderer.shadowMap.autoUpdate = true;
    renderer.receiveShadow = true;
    document.body.appendChild(renderer.domElement);

    window.addEventListener(
      "resize",
      () => {
        _OnWindowResize(this.camera);
      },
      false
    );
    var _OnWindowResize = function (camera) {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
      document.getElementById("modal").style.height = window.height;
      document.getElementById("modal").style.width = window.width;
      document.getElementById("about").style.height = window.height;
      document.getElementById("about").style.width = window.width;
    };

    this.scene = new THREE.Scene();
    this.scene.fog = new THREE.Fog("#000005", 1, 3000);

    geometry = new THREE.PlaneGeometry( 46, 25.5 );
    material = new THREE.MeshBasicMaterial( {map: new THREE.TextureLoader().load( "Images/statefarm.png" ), color: 0xffffff, side: THREE.DoubleSide} );
    var plane = new THREE.Mesh( geometry, material );
    plane.position.set(-37.25, 41.5,-7.5)
    plane.rotation.y = Math.PI/2;
    plane.name = 'SmallBusiness'
    this.scene.add( plane );

    const myText = new Text()
    this.scene.add(myText)

    myText.text = 'A GOOD NEIGHBOR!'
    myText.fontSize = 100
    myText.position.set(-550, 100, -300)
    myText.color = 0xF01716

    // Update the rendering:
    myText.sync()

    const getShadow = function(scene, gltf){
        const s = new THREE.Box3().setFromObject(gltf.scene).getSize(new THREE.Vector3(0, 0, 0));
        const sizes = [s.x, s.y, s.z];
        const planeSize = Math.max(...sizes) * 10;
        const planeGeo = new THREE.PlaneBufferGeometry(planeSize, planeSize);
        const planeMat = new THREE.ShadowMaterial();
        planeMat.opacity = 0.85;
        plane = new THREE.Mesh(planeGeo, planeMat);
        plane.rotateX(-Math.PI / 2);
        plane.receiveShadow = true;
        scene.add(plane);
    }
    var manager = new THREE.LoadingManager();

    manager.onProgress = function (item, loaded, total) {
        // console.log(item, loaded, total);
    };
    manager.onLoad = function () {
      console.log("all items loaded");
      document.getElementById("header").style.display = "block";
      document.getElementById("loading").style.display = "none";
      // document.getElementById("header").style.display = "block";

    };
    manager.onError = function () {
      console.log("there has been an error");
    };

    // load Living Room
    var loadLivingRoom = function async(scene) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/living-room/room/room.gltf", (gltf) => {
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            node.receiveShadow = true;
            node.castShadow = true
            if(node.name.includes('Object_4')) {
              node.name = 'SmallBusiness'
              
              const texture = new THREE.TextureLoader().load( "Images/statefarm.png" );
              node.material = new THREE.MeshLambertMaterial( { map: texture, side: THREE.DoubleSide, } );
              
            
            } else if (node.name.includes('Object_2')){
              node.name = 'Window'
              
              const texture = new THREE.TextureLoader().load( "Images/statefarm.png" );
              node.material = new THREE.MeshLambertMaterial( {map: texture, side: THREE.DoubleSide, } );
              node.material.transparent = true
              node.material.opacity = 0

            }
            else {
              node.name = 'home'
              var color = node.material.color;
              node.material = new THREE.MeshStandardMaterial({
                side: THREE.DoubleSide,
                color: color,
              });
              
            }
          }
        });
        getShadow(scene,gltf)
        gltf.castShadow = true;
        gltf.scene.castShadow = true;
        const root = gltf.scene;
        root.name = 'home';
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZYX";
        root.rotation.y = 1/2*Math.PI;
        root.scale.set(50,50,50)
        root.position.set(0,-7,0)
        scene.add(root);
      });
    };
    loadLivingRoom(this.scene);


    // load life
    var loadlife = function async(scene, mixer, mixers) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/woman/dance/scene.gltf", (gltf) => {
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            node.name = 'life';
            node.castShadow = true;
            node.receiveShadow = true;
            let temp = node.material.color;
            node.material = new THREE.MeshStandardMaterial({
              color: temp,
              roughness: 0.6,
              metalness: 0.2,
              // emissive: 0xfff,
            });
          }
        });
        getShadow(scene,gltf)
        mixer = new THREE.AnimationMixer(gltf.scene)
        mixers.push(mixer)//pose
        mixer.clipAction(gltf.animations[0]).play()
        gltf.castShadow = true;
        gltf.scene.castShadow = true;
        const root = gltf.scene;
        root.name = "life";
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZYX";
        root.rotation.y = Math.PI/2*4;
        root.position.set(100,0, 0)
        let scale = 0.25
        root.scale.set(scale, scale, scale)
        scene.add(root);
      });
    };
    loadlife(this.scene, this.mixer, this.mixers);

    // load Truck
    var loadTruck = function async(scene, mixer, mixers) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/truck/truck/scene.gltf", (gltf) => {
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            node.name = 'auto'
            node.castShadow = true;
            node.receiveShadow = true;
            let temp = node.material.color;
            node.material = new THREE.MeshStandardMaterial({
              color: temp,
              roughness: 0.6,
              metalness: 0.4,
              // emissive: 0xfff,
            });
          }
        });
        getShadow(scene,gltf)
        mixer = new THREE.AnimationMixer(gltf.scene)
        mixers.push(mixer)//pose
        mixer.clipAction(gltf.animations[0]).play()
        gltf.castShadow = true;
        gltf.scene.castShadow = true;
        const root = gltf.scene;
        root.name = "auto";
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZYX";
        root.rotation.y = 3/2*Math.PI;
        root.position.set(-85,6,0)
        let scale = 0.15
        root.scale.set(scale, scale, scale)
        scene.add(root);
      });
    };
    loadTruck(this.scene, this.mixer, this.mixers);

    // load Dog
    var loadDog = function async(scene, mixer, mixers) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/dog/dog/scene.gltf", (gltf) => {
        
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            node.name = 'pet'
            node.castShadow = true;
            node.receiveShadow = true;
            let temp = node.material.color;
            node.material = new THREE.MeshBasicMaterial({
              color: temp,
              roughness: 0.6,
              metalness: 0.4,
              side: THREE.DoubleSide,

              // emissive: 0xfff,
            });
          }
        });
        getShadow(scene,gltf)
        mixer = new THREE.AnimationMixer(gltf.scene)
        mixers.push(mixer)//pose
        mixer.clipAction(gltf.animations[3]).play()
        gltf.castShadow = true;
        gltf.scene.castShadow = true;
        const root = gltf.scene;
        root.name = "pet";
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZYX";
        root.rotation.y = 1/4*Math.PI;
        root.position.set(35,7,50)
        let scale = 1
        root.scale.set(scale, scale, scale)
        scene.add(root);
      });
    };
    loadDog(this.scene, this.mixer, this.mixers);

    // load Space Craft
    var loadSpace = function async(scene, mixer, mixers) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/spacecraft/spacecraft/scene.gltf", (gltf) => {
        
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            node.name = 'ClickMe'
            node.castShadow = true;
            node.receiveShadow = true;
            let temp = node.material.color;
            node.material = new THREE.MeshStandardMaterial({
              color: temp,
              roughness: 0.6,
              metalness: 0.4,
              side: THREE.DoubleSide,

              // emissive: 0xfff,
            });
          }
        });
        getShadow(scene,gltf)
        mixer = new THREE.AnimationMixer(gltf.scene)
        mixers.push(mixer)//pose
        mixer.clipAction(gltf.animations[0]).play()
        gltf.castShadow = true;
        const root = gltf.scene;
        root.name = "ClickMe";
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZYX";
        root.rotation.y = 1/4*Math.PI;
        root.position.set(150,55,-500)
        let scale = 0.1
        root.scale.set(scale, scale, scale)
        scene.add(root);
      });
    };
    loadSpace(this.scene, this.mixer, this.mixers);


    // load Health
    var loadHealth = function async(scene, mixer, mixers) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/dr/health/scene.gltf", (gltf) => {
        
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            node.name = 'health'
            node.castShadow = true;
            node.receiveShadow = true;
            node.material = new THREE.MeshStandardMaterial({
              color: 0xF01716,
              transparent: true,
              side: THREE.DoubleSide,
            });
          }
        });
        mixer = new THREE.AnimationMixer(gltf.scene)
        mixers.push(mixer)//pose
        mixer.clipAction(gltf.animations[0]).play()
        gltf.castShadow = true;
        gltf.scene.castShadow = true;
        const root = gltf.scene;
        root.name = "health";
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZYX";
        root.rotation.y = 1/4*Math.PI;
        root.position.set(-10,14,50)
        let scale = 10
        root.scale.set(scale, scale, scale)
        scene.add(root);
      });
    };
    loadHealth(this.scene, this.mixer, this.mixers);


    var geometry = new THREE.SphereGeometry(1.5, 20, 20);
    var material = new THREE.MeshToonMaterial({
      color: "#555",
    });

    var lights = new THREE.DirectionalLight(0xffffff, 1);
    lights.position.set(50, 100, 50)
    lights.castShadow = true
    lights.shadow.radius = 2
    lights.shadow.mapSize.width = 8192
    lights.shadow.mapSize.height = 8192
    lights.shadow.camera.top = lights.shadow.camera.right = 1000
    lights.shadow.camera.bottom = lights.shadow.camera.left = -1000
    lights.shadow.camera.near = 1
    lights.shadow.camera.far = 400000000
    lights.shadow.camera.visible = true
    lights.shadowDarkness = 0.5;
    this.scene.add(lights);

    // // Hemisphere Light
    var lights = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.2);
    this.scene.add(lights);

    // Spot Light = // SUN
    // var spotLight = this.getPointLight(1, "#000000");
    // spotLight.castShadow = true
    // this.scene.add(spotLight);

    const light = new THREE.AmbientLight( 0xffffff ); // soft white light
    this.scene.add( light );

    var pos = this.angles2xyz(25, -5, 500);
    new TWEEN.Tween({
      x: 0,
      y: 0,
      z: 0,
    })
		.to({ x: pos[0], y: pos[1], z: pos[2] }, 4000)
		.onUpdate(function (val) {
			parent.camera.position.x = val.x;
			parent.camera.position.y = val.y;
			parent.camera.position.z = val.z;
		})
		.easing(TWEEN.Easing.Back.Out)
		.repeat()
		.start()

    	// INTRO
		.onComplete(() => {
			document.getElementById('intro').style.display = 'flex';
		});

    var cameraZposition = new THREE.Group();
    var cameraXRotation = new THREE.Group();
    var cameraYRotation = new THREE.Group();

    cameraZposition.add(this.camera);
    cameraXRotation.add(cameraZposition);
    cameraYRotation.add(cameraXRotation);

    renderer.sortObjects = false;
    renderer.render(this.scene, cameraYRotation);
    renderer.shadowMap.renderSingleSided = false;
    renderer.setClearColor(0x000000,0);


    var getFromDB = function (){
      console.log('getting from DB')


    }
    getFromDB()

    var update = function (
      renderer,
      scene,
      camera,
      controls,
      raycaster,
      mouse,
      mixers,
      clock
    ) {
      renderer.render(scene, camera);
      controls.update();

      TWEEN.update();



      // animation setup
    // var animate = function () {
      
      // requestAnimationFrame( animate );
      
      var delta = clock.getDelta();
      if(mixers) mixers.map(m => m.update(delta) )


    

    //   threejs.render( scene, camera );
    // // };
    // animate();




      requestAnimationFrame(function () {
        update(renderer, scene, camera, controls, raycaster, mouse, mixers, clock);
      });
    };

    var controls = new OrbitControls(this.camera, renderer.domElement);
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.dampingFactor = 0.075;
    controls.minDistance = 150;
    controls.maxDistance = 700;
    controls.target.set(-20, 50, 0)

    update(
      renderer,
      this.scene,
      this.camera,
      controls,
      this.raycaster,
      this.mouse,
      this.mixers,
      clock
    );

    window.addEventListener(
      "mousemove",
      (event) =>
        this.onMouseMove(
          event,
          this.mouse,
          this.raycaster,
          this.camera,
          this.scene,
        ),
      false
    );

    window.addEventListener(
      "click",
      (event) =>
        this.mouseClick(this.scene, this.raycaster, this.mouse, this.camera),
      false
    );
  }

  getSpotLight(intensity, color) {
    var light = new THREE.SpotLight(color, intensity);
    light.position.set(1, 2, 1);
    light.castShadow = true;
    light.shadow.bias = 0.001;
    light.penumbra = 1;
    light.angle = 1;
    light.decay = 1;
    light.distance = 4000;
    light.shadow.mapSize.width = 2048 * 4;
    light.shadow.mapSize.height = 2048 * 4;
    light.shadow.camera.near = 5;
    light.shadow.camera.far = 1000;
    return light;
  }

  render() {
    return (
      <>
        <Header />
        <Loading />
        <Modal />
        <Intro />
        <About />
        <Tooltip />
        {/* <image src='/Images/SF_logo.PNG'></image> */}
        {/* {this.target && <Rates target={this.target}/>} */}

        {/* <Leaderboard leader="hh" /> */}
      </>
    );
  }
}

export default AA;
